import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { some as _some } from 'lodash';

import { ApiStatus } from '@amfam/shared/models';

import * as fromRoot from '../../core/store';
import * as fromPolicyChangeContainer from '../+state';
import {
  PolicyChangeRequestNotificationAction,
  PolicyChangeRequestResetStateAction
} from '../+state/policy-change.actions';
import { PlchangerequestComponent } from '../containers';

@Injectable()
export class ChangeRequestErrorGuard {
  private emailNotificationError: ApiStatus;

  constructor(private store: Store<fromRoot.RootState>) {
    this.store
      .select(fromPolicyChangeContainer.selectPolicyChangePageError)
      .subscribe(errorNotification => {
        this.emailNotificationError = errorNotification;
      });
  }
  /*
    canDeactivate method takes Component, ActivatedRouteSnapshot,RouterStateSnapshot, nextState: RouterStateSnapshot as parameters.
    nextState gives us future url.
  */
  canDeactivate(
    component: PlchangerequestComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): any {
    // Clear the list when navigated to rest of the app except registration flow.
    if (nextState.url !== '/policies/changerequest' && _some(this.emailNotificationError)) {
      this.store.dispatch(PolicyChangeRequestResetStateAction());
    }

    return true;
  }
}
